import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Profile = () => {
  const { role } = useAuth();

  // Redirect to role-specific profile
  if (role === 'customer') return <Navigate to="/profile" replace />;
  if (role === 'seller') return <Navigate to="/seller/profile" replace />;
  if (role === 'admin') return <Navigate to="/admin/profile" replace />;

  return <Navigate to="/login" replace />;
};

export default Profile;